module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-5@2x-5ccb43b7879593c5840e063a0ef393bb.png";